import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";
import { getVideosByCategory } from "@/utils/video";

export default function CategoryQuickEntry() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className="group flex flex-col items-center gap-2 py-5 px-2 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
        >
          <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className={cat.icon}></i>
          </span>
          <span className="text-sm font-medium text-foreground-900">{cat.name}</span>
          <span className="text-xs text-foreground-500">{getVideosByCategory(cat.slug).length} 个视频</span>
        </Link>
      ))}
    </div>
  );
}